import { MessageCollection } from '@sendbird/chat/groupChannel';
import { FileMessage } from '@sendbird/chat/message';

export const getAllFileMessages = (
  messageCollection: MessageCollection | null
) => {
  return [
    ...(messageCollection?.pendingMessages ?? []),
    ...(messageCollection?.failedMessages ?? []),
    ...(messageCollection?.succeededMessages ?? []),
  ] as FileMessage[];
};
